export default __webpack_public_path__ + "static/media/RegEx_-_adamr.space___Codecademy.538e4870.pdf";